import styled from 'styled-components';

export const HeaderWrapper = styled.header`
    position: fixed;
    inset: 0;
    display: flex;
    width: 100%;
    padding: 1rem 1.5rem;
    justify-content: space-between;
    align-items: center;
    height: 5rem;
    background: var(--neutral-950-opacity, rgba(9, 9, 11, 0.6));
    backdrop-filter: blur(25px);
    z-index: 2;

    a {
        color: ${({ theme }) => theme.colors['neutral-100']};
        font-size: 1rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1.5rem;
        text-decoration: none;
    }

    @media (max-width: 900px) {
        & {
            display: none;
        }
    }
`;

export const LogoHeader = styled.div`
    div {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const NavWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    flex-grow: 1;

    color: ${({ theme }) => theme.colors['neutral-100']};
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5rem;

    a {
        position: relative;
        overflow: hidden;
        font-size: 1rem;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 0%;
            height: 2px;
            background-color: white;
            transition: width 0.3s ease;
        }

        &:hover::before,
        &.open::before {
            width: 100%;
        }
    }

    a.expandable-link {
        display: flex;
        align-items: center;
        gap: 0.25rem;
        cursor: pointer;

        svg {
            height: 1.25rem;
            width: 1.25rem;
            color: #f4f4f5;
        }
    }
`;

export const UserAreaWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;

    svg {
        width: 1.5rem;
        height: 1.5rem;
        flex-shrink: 0;
        color: #ffffff;
    }

    .user-button {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-shrink: 0;
        gap: 0.25rem;

        p {
            color: var(--Neutral-100, #f4f4f5);
            font-size: 1rem;
            font-weight: 500;
            line-height: 1.5rem;
        }
    }

    button.shopping-cart {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.25rem;
        font-weight: 500;
        line-height: 1.5rem;
        color: #ffffff;

        padding: 0.1rem 0.1rem;
    }

    .login-area {
        display: flex;
        gap: .75rem;
        align-items: center;

        button {
            padding: .5rem .75rem;
            font-size: 1rem;
            border-radius: 0.5rem;
        }
    }
`;

export const WrapperToPopup = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center;
`;
